import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import { filter, orderBy } from 'lodash';
import ChannelResultItem from './ChannelResultItem';

class CollapsableChannels extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
    }
  }

  toggle = () => {
    this.setState(state => ({ collapse: !state.collapse }));
  }

  render() {
    const { item, channelSelect, dmaID, rsn, selectedChannels } = this.props;

    const url_string = window.location.href;
    const url = new URL(url_string);
    const color = url.searchParams.get("color");

    let channelCatNameStyles;
    channelCatNameStyles = {
      background: '#ffffff',
    }

    return (
      <div>
        <div>
          <h6 className="title channel-cat-name d-flex align-items-center justify-content-between" style={channelCatNameStyles} onClick={this.toggle}>{item.name} {this.state.collapse === false ? <i className="fal fa-chevron-down"></i> : <i className="fal fa-chevron-up"></i>}</h6>
        </div>
        <Collapse isOpen={this.state.collapse}>
          <div className="filter-content">
            <div className="card-body d-flex flex-column">
              {
                this.props.view === 'list' ?
                  this.props.channels.map((channel, index) => (
                    <ChannelResultItem channel={channel} onChannelSelect={(id) => channelSelect(id)} key={index} selectedChannels={selectedChannels} />
                  )) :
                  orderBy(item.channels, 'name')
                    .filter((channel) => (channel.dma_code === 'not_set' || channel.dma_code === dmaID))
                    .map((channel, index) => (
                      <ChannelResultItem channel={channel} onChannelSelect={(id) => channelSelect(id)} key={index} selectedChannels={selectedChannels} />
                    ))
              }
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}
export default CollapsableChannels;



// WEBPACK FOOTER //
// ./src/components/Picker/CollapsableChannels.js